var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-balance-detail',{staticClass:"pt-balance-detail__withData",attrs:{"detail":_vm.detail,"departmentList":_vm.departmentList},on:{"deleteBalanceDetail":_vm.deleteBalanceDetail,"getBalanceDetail":_vm.getDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }